import React from "react";
import AppButton from "../../../../../../AppComponents/AppButton";
import {
  AppForm,
  AppSubmitButton,
} from "../../../../../../AppComponents/Forms";
import { generateResolveVariables } from "../../../../../../Components/Broadcast/WhatsApp/Utils/utils";
import { useNotification } from "../../../../../../Hooks/useNotification/useNotification";
import { useAppDispatch, useAppSelector } from "../../../../../../Store";
import {
  allMessagesStore,
  setAllMessages,
} from "../../../../../../Store/Slices/socket/AllMessagesSlice";
import { useLiveChatWhatsappTemplateData } from "../../../../../../Store/Slices/socket/liveChatWhatsappTemplateSelect/LiveChatWhatsappTemplateSelect.selectors";
import { setResolovedFormData } from "../../../../../../Store/Slices/socket/liveChatWhatsappTemplateSelect/LiveChatWhatsappTemplateSelect.slice";
import {
  MESSAGE_TYPES, SOCKET_CONNECTION_TYPES,
} from "../../../../../utils/Enum";
import ResolveWhatsappVariables from "./ResolveWhatsappVariables";
import { WhatsappBroadcastScheduleStep3Schema } from "../../../../../../Components/Broadcast/Email/Utils/Constants";
import { scheduleSchema } from "../../../../../../Models/ValidationSchema";
import { ChatNetworkService } from "../../../../../../Store/Slices/socket/liveChat/ChatNetworkService";
import { useSocket } from "../../../../../hooks/socket-context";
import { convertFormToPayloadSingleWhatsappBroadcast } from "../../../../../../Components/Leads/contact-action/utils/constants";
import { WhatsappNetworkService } from "../../../../../../Store/Slices/Whatsapp/WhatsappNetworkService";
interface Props {
  isShowing: boolean;
  toggle: (val?: boolean | undefined) => void;
}

const ModelBody: React.FC<Props> = ({ isShowing, toggle }) => {
  const { showAlert } = useNotification();
  const dispatch = useAppDispatch();
  const { socket } = useSocket();
  const { userInfoData } = useAppSelector(allMessagesStore);

  const { sessionId, lastNodeResponse } = useAppSelector(allMessagesStore);

  const payloadObject = (values: any) => {
    let payload: any = {
      components: {},
    };
    if (values?.resolved_header_variables?.length > 0) {
      payload["components"]["header"] = {
        type: values?.header_type,
        value:
          values?.header_type === "text"
            ? values?.resolved_header_variables?.[0]?.value
            : values?.resolved_header_variables?.[0]?.value?.source,
        index:
          values?.header_type === "text"
            ? values?.resolved_header_variables?.[0]?.index
            : null,
      };
    }
    if (values?.resolved_body_variables?.length > 0) {
      payload["components"]["body"] = {
        value: values?.resolved_body_variables,
      };
    }
    if (values?.resolved_buttons_variables?.length > 0) {
      payload["components"]["button"] = {
        value: values?.resolved_buttons_variables,
        type: "dynamic",
      };
    }
    return payload;
  };
  const handleContinueClick = (values: any, submitProps: any) => {
    let userInput: string = values?.body_preview || "";
    
    if (!userInput || userInput?.length < 1) {
      return;
    }

    let payload = convertFormToPayloadSingleWhatsappBroadcast(values)
    payload['broadcast_template_id'] = values?.id
    payload['sender_field'] = "mobile_phone_number"
    payload['sender_field_value'] = userInfoData?.phone
    payload['contact_id'] = userInfoData?.contact_id
    WhatsappNetworkService.sendWhatsappMessage(payload)
      .then((res: any) => {
        showAlert(res?.data?.message || "Message sent!", "success");
        toggle(false);
      })
      .catch((error: any) => {
        showAlert(error?.response?.statusText || "Message sending failed", "error");
      })
      .finally(() => {
        toggle(false);
      });
    // if (typeof values === "string") {
    //   userInput = values || "";
    // } else if (typeof values === "object" && !isEmptyObject(values)) {
    //   let firstValue: string = String(Object?.values(values)[0]) || "";
    //   userInput = firstValue;
    // } else {
    //   userInput = "";
    // }

    
    // let data = {
    //   type: MESSAGE_TYPES.TEXT,
    //   isUser: false,
    //   value: userInput,
    //   userId: socket?.id,
    //   session_id: sessionId,
    //   conversation_id: lastNodeResponse?.conversation_id,
    // };

    // dispatch(setAllMessages([data]));
    // // if (socket?.connected) {
    //   socket?.emit(SOCKET_CONNECTION_TYPES.AGENT_CHAT, data);
    // // }

    // dispatch(setResolovedFormData(values));
    // // alert("continue");
    // submitProps.setSubmitting(false);
    // toggle(false);
    return;
  };

  const { whatsappTemplateData, selectedTemplateData } = useAppSelector(
    useLiveChatWhatsappTemplateData,
  );

  const [userInput, setUserInput] = React.useState<any>({
    resolved_header_variables: [],
    resolved_body_variables: [],
    header_type: "text",
    resolved_buttons_variables: [],
    footer_value: "",
    header_media: null,
    originalTemplateData: selectedTemplateData,
    modifiedTemplateData: null,
    body_preview: "",
  });

  React.useEffect(() => {
    if (selectedTemplateData) {
      let type = selectedTemplateData?.components?.header?.header_type;
      let a =
        type === "text"
          ? generateResolveVariables(
              selectedTemplateData?.components?.header?.value?.value,
              selectedTemplateData?.components?.header?.value?.header_text,
            )
          : [];
      let c =
        type !== "text"
          ? selectedTemplateData?.components?.header?.value
          : null;
      let b =
        generateResolveVariables(
          selectedTemplateData?.components?.body?.value,
          selectedTemplateData?.components?.body?.body_text,
        ) || [];
      setUserInput({
        resolved_header_variables:
          type === "media"
            ? [
                {
                  key: "{{1}}",
                  value: "",
                  index: 0,
                  type: type,
                },
              ]
            : a,
        header_media: c,
        header_type: type,
        resolved_body_variables: b,
        resolved_buttons_variables: [],
        footer_value: selectedTemplateData?.components?.footer?.value,
        originalTemplateData: selectedTemplateData,
        modifiedTemplateData: null,
        body_preview: selectedTemplateData?.components?.body?.value,
        id: selectedTemplateData?.id,
      });
    }
  }, [selectedTemplateData]);

  const handleCancelClick = () => {
    toggle(false);
    // dispatch(removeLiveChatWhatsappTemplateSelectData());
  };

  if (!selectedTemplateData || !userInput?.body_preview) {
    return (
      <p
        style={{
          display: "flex",
          width: "calc(100% - 269px)",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        Select a template first.
      </p>
    );
  }

  return (
    <>
      <AppForm
        initialValues={userInput}
        onSubmit={(values: any, submitProps: any) => {
          handleContinueClick(values, submitProps);
        }}
        validationSchema={scheduleSchema}
        divStyle={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: "0.5rem",
        }}
      >
        <div className="modelBodyRight">
          {selectedTemplateData?.name}

          <ResolveWhatsappVariables />
        </div>

        <div className="modelFooter">
          <div className="modelFooterAction">
            <AppButton variant="danger" onClick={() => handleCancelClick()}>
              Cancel
            </AppButton>
            <AppSubmitButton title="Continue" />
          </div>
        </div>
      </AppForm>
    </>
  );
};

export default ModelBody;
